"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RenderEmailMessage = function RenderEmailMessage(_ref) {
  var messageInfo = _ref.messageInfo,
    sentAt = _ref.sentAt,
    status = _ref.status;
  var localInfo = _objectSpread({
    date: sentAt,
    from: '',
    subject: '',
    to: ''
  }, _typeof(messageInfo) === 'object' ? messageInfo : {});
  var headerRegexes = {
    date: /Date: ([^\r\n]+)/,
    from: /From: ([^\r\n]+)/,
    subject: /Subject: ([^\r\n]+)/,
    to: /To: ([^\r\n]+)/
  };
  for (var _i = 0, _Object$keys = Object.keys(headerRegexes); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var tempMatch = (messageInfo === null || messageInfo === void 0 ? void 0 : messageInfo.headers) && messageInfo.headers.match(headerRegexes[key]);
    if (tempMatch && tempMatch.length > 1 && !localInfo[key]) {
      localInfo[key] = tempMatch[1];
    }
  }
  var statusClass = 'bg-success';
  var okStatuses = ['sent', 'enqueued', 'Delivery'];
  if (!okStatuses.includes(status)) {
    statusClass = 'bg-danger';
  }
  if (status === 'enqueued') {
    statusClass = 'bg-info';
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].emailHeaders, statusClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('float-end', _style["default"].emailStatus)
  }, "Status: ", status), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerRow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerName
  }, "To:"), " ", localInfo.to), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerRow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerName
  }, "Date:"), " ", localInfo.date), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerRow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerName
  }, "Subject:"), " ", localInfo.subject)), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: messageInfo && (messageInfo.html || messageInfo.body) || ''
  }));
};
var _default = exports["default"] = RenderEmailMessage;